module.exports = __webpack_public_path__ + "img/Martin-Saavedra-byn.0dcc2cdd.jpg";